module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "260px"
    }
  }, [(_vm.row.saiqu.is_jiesong == 1) ? _c('van-notice-bar', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n        此项费用包含: 车站到酒店的接送站费用、住宿费、餐费及赛场到酒店的接驳费（如涉及）。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.is_jiesong == 2) ? _c('van-notice-bar', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n        本次比赛不提供接送站服务，此项费用包含: 住宿费、餐费及赛场到酒店的接驳费（如涉及）。\n      ")]) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("确认信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.orderData.list), function(room, rindex) {
    return _c('el-col', {
      key: rindex,
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": room.name,
        "prop": "name"
      }
    }, [_c('el-input-number', {
      attrs: {
        "min": 0,
        "max": 1000
      },
      on: {
        "change": _vm.countChange
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "额外食宿费用",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "input": _vm.countChange
    },
    model: {
      value: (_vm.row.shisu_fix),
      callback: function($$v) {
        _vm.$set(_vm.row, "shisu_fix", $$v)
      },
      expression: "row.shisu_fix"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "食宿费用",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.orderData.price) + "元\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "食宿人数",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.sai_member_count) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可入住人数",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.orderData.count) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")]), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showRoomTypePicker),
      callback: function($$v) {
        _vm.showRoomTypePicker = $$v
      },
      expression: "showRoomTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.row.room_type,
      "show-toolbar": "",
      "value-key": "name",
      "default-index": 0
    },
    on: {
      "cancel": function($event) {
        _vm.showRoomTypePicker = false
      },
      "confirm": _vm.onRoomTypeConfirm
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f6968c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep4Admin.vue
// module id = 1406
// module chunks = 0